<template>
    <div>
        <div class="card mb-3 bg-primary">
            <div class="card-body">
                <h5 class="text-white font-weight-light mb-0"><b>{{ guia }}</b></h5>
            </div>
        </div>
        <div class="card mb-4">
            <div class="card-body border-0">
                <p class="mb-1"><b>{{ name }}</b></p>
                <p class="mb-0"><b>Evento:</b> {{ tracking.Evento }}</p>
                <p class="mb-0"><b>Fecha del evento:</b> {{ onFormat(tracking.FechaEvento, data.Pais) }}</p>
                <p class="mb-0"><b>Ubicacion:</b> {{ tracking.Ubicacion }}</p>
                <p class="mb-0"><b>Categoría:</b> {{ category }}</p>
            </div>
        </div>
        <div class="mb-4">
        </div>
    </div>
</template>
<script>
import moment from 'moment-timezone'
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    name: function () {
      return this.data.InfoPaquete[0].Nombre || ''
    },
    guia: function () {
      return this.data.InfoPaquete[0].Guia || ''
    },
    category: function () {
      return this.data.InfoPaquete[0].Categoria || ''
    },
    tracking: function () {
      return this.data.InfoTrackingPaquete[0] || {}
    }
  },
  methods: {
    onFormat: function (date, country) {
      var gt = moment.tz(String(date), 'DD/MM/YYYY hh:mm:ss', country)
      var guatemala = gt.clone().tz('America/Guatemala')
      return guatemala.format('YYYY/MM/DD hh:mm A')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/components/Result.vue